@if (!isCurrent) {
  <td>
    <strong>
      <a uiSref="a.business_order.view" target="_blank" [uiParams]="{id: bo.id, index: bo.index}">
        {{bo.id}}-{{bo.index}}
      </a>
    </strong>&nbsp;
    @if (!!reproduction) {
      <div class="label label-danger"
        ngbTooltip="Nachfertigung"
        >
        NF&nbsp;
        @if (!isParentCurrent) {
          <a uiSref="a.business_order.view"
            target="_blank"
            style="color: #fff !important;"
            [uiParams]="{id: reproduction.parent_id, index: reproduction.parent_index}"
            >
            ({{reproduction.parent_id}}-{{reproduction.parent_index}})
          </a>
        }
        @if (isParentCurrent) {
          ({{reproduction.parent_id}}-{{reproduction.parent_index}})
        }
      </div>
    }
  </td>
}
@if (!isCurrent) {
  <td><strong>+&nbsp;{{bo.good_piece|money}}</strong></td>
}

@if (isCurrent) {
  <td>
    <strong ngbTooltip="dieser BA">
      {{bo.id}}-{{bo.index}}
    </strong>&nbsp;
    @if (!!reproduction) {
      <div class="label label-danger"
        ngbTooltip="Nachfertigung"
        >
        NF&nbsp;
        <a uiSref="a.business_order.view"
          target="_blank"
          style="color: #fff !important;"
          [uiParams]="{id: reproduction.parent_id, index: reproduction.parent_index}">
          ({{reproduction.parent_id}}-{{reproduction.parent_index}})
        </a>
      </div>
    }
  </td>
}
@if (isCurrent) {
  <td></td>
}
